import React, { useState, useEffect } from "react";
import { Row, Col, Drawer } from "antd";
import { API } from "aws-amplify";
import Moment from "moment";
import { CloseSquareFilled, FolderOpenOutlined } from "@ant-design/icons";
import MainHeader from "../../../../common/MainHeader";
import ScriptCard from "../../../../common/ScriptCard";

export default function RecentActivity(props) {
  const [screenResolutionWidth, setScreenResolutionWidth] = useState(0);
  const [isMobileDevice, setIsMobileDevice] = useState(false);
  // const [loadingQuestions, setLoadingQuestions] = useState(false);
  // const [scriptItem, setscriptItem] = useState({});
  // const [questionList, setquestionList] = useState([]);
  // const [filterList, setfilterList] = useState([]);
  // const [scriptUpdateTime, setScriptUpdateTime] = useState(null);
  const [profileNames, setProfileNames] = useState(null);
  const [showAllScripts, setShowAllScripts] = useState(false);

  // const [enableCalendar, setEnableCalendar] = useState(false);
  // const [enableHistory, setEnableHistory] = useState(false);
  const [questionHistoryList, setQuestionHistoryList] = useState([]);
  // const [selectedStartDate, setSelectedStartDate] = useState("");
  // const [selectedEndDate, setSelectedEndDate] = useState("");
  // const [displayStartDate, setDisplayStartDate] = useState("");
  // const [displayEndDate, setDisplayEndDate] = useState("");

  // const [fromDatePicker, setFromDatePicker] = useState(false);
  // const [toDatePicker, setToDatePicker] = useState(false);
  // const [selectedFromDate, setSelectedFromDate] = useState("");
  // const [selectedToDate, setSelectedToDate] = useState("");
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedDates, setSelectedDates] = useState([]);
  // const [renderSwitchDates, setRenderSwitchDates] = useState(false);
  // const [compareAnswers, setCompareAnswers] = useState([]);
  // const [showScriptMainHeader, setShowScriptMainHeader] = useState(false);
  // const [testname, setTestName] = useState(1);
  // const [enablePagination, setEnablePagination] = useState(false);

  useEffect(() => {
    const box = document.getElementById("recentActivityParent");
    setScreenResolutionWidth(box.offsetWidth);
  });

  useEffect(() => {
    const {
      criticalInfoScriptId,
      profileId,
      orgId,
      profileUserNames,
      isMobile,
    } = props;
    if (criticalInfoScriptId && profileId && orgId) {
      const startDate = Moment(new Date()).format("MM-DD-YYYY");
      const endDate = Moment(new Date())
        .subtract(30, "days")
        .format("MM-DD-YYYY");
      getScriptHistoryQuestions(endDate, startDate);
    }

    if (profileUserNames) {
      setProfileNames(profileUserNames);
    }

    if (isMobile) {
      setIsMobileDevice(isMobile);
    }
  }, [props]);

  const getSelectedDate = (switchDate) => {
    setSelectedDate(switchDate);
  };

  // const getYesterdayDate = () => {
  //   setEnablePagination(false);
  //   const yesterdayDate = Moment(new Date())
  //     .subtract(1, "days")
  //     .format("MM-DD-YYYY");
  //   getScriptHistoryQuestions(yesterdayDate, yesterdayDate);
  // };

  // const getLastDates = () => {
  //   setEnablePagination(false);
  //   const startDate = Moment(new Date()).format("MM-DD-YYYY");
  //   const endDate = Moment(new Date()).subtract(7, "days").format("MM-DD-YYYY");
  //   getScriptHistoryQuestions(endDate, startDate);
  // };

  // const getSelectedDates = () => {
  //   if (selectedFromDate === "") {
  //     alert("Please Select From Date");
  //     return true;
  //   }
  //   if (selectedToDate === "") {
  //     alert("Please Select To Date");
  //     return true;
  //   }
  //   if (selectedFromDate.substring(0, 2) === selectedToDate.substring(0, 2)) {
  //     getScriptHistoryQuestions(selectedFromDate, selectedToDate);
  //   } else {
  //     getPaginationDates("next");
  //   }
  // };

  // const getPaginationDates = async (action) => {
  //   setEnablePagination(true);
  //   let startDate;
  //   let endDate;
  //   if (action === "next") {
  //     startDate = selectedStartDate;
  //     endDate = Moment(selectedStartDate, "MM-DD-YYYY")
  //       .add("30", "days")
  //       .format("MM-DD-YYYY");
  //     setSelectedStartDate(endDate);
  //   } else {
  //     startDate = Moment(selectedStartDate, "MM-DD-YYYY")
  //       .subtract("30", "days")
  //       .format("MM-DD-YYYY");
  //     endDate = selectedStartDate;
  //     setSelectedStartDate(startDate);
  //   }
  //   getScriptHistoryQuestions(startDate, endDate);
  // };

  const getScriptHistoryQuestions = async (fromDate, toDate) => {
    // setDisplayStartDate(fromDate);
    // setDisplayEndDate(toDate);
    // setEnableCalendar(false);
    // setLoadingQuestions(true);
    const { criticalInfoScriptId, profileId, orgId } = props;
    await API.get(
      "list",
      `/mobile/list/getUserQuestionHistory/${criticalInfoScriptId}/${profileId}/${orgId}/${fromDate}/${toDate}`,
      {}
    )
      .then((response) => {
        settingScriptHistoryQuestionsList(response);
        resetDateValues();
      })
      .catch((error) => {
        resetDateValues();
        console.log("Error:", error);
      });
  };

  const settingScriptHistoryQuestionsList = async (response) => {
    if (response.selectedDates) {
      setSelectedDates(response.selectedDates);
      setSelectedDate(response.selectedDates[0]);
    }
    if (response.questions) {
      const arr = [];
      for (const key in response.questions) {
        arr.push({
          cat: key,
          questionList: response.questions[key],
          collapse: true,
        });
      }
      setQuestionHistoryList(arr);
    }
    // setEnableHistory(true);
    // setscriptItem(response);
  };

  // const showFromDatePicker = () => {
  //   Keyboard.dismiss();
  //   setFromDatePicker(true);
  // };

  // const hideFromDatePicker = () => {
  //   setFromDatePicker(false);
  // };

  // const handleFromDate = (pickedFromDate) => {
  //   setFromDatePicker(false);
  //   setSelectedFromDate(Moment(pickedFromDate).format("MM-DD-YYYY"));
  //   setSelectedStartDate(Moment(pickedFromDate).format("MM-DD-YYYY"));
  // };

  // const showToDatePicker = () => {
  //   Keyboard.dismiss();
  //   setToDatePicker(true);
  // };

  // const hideToDatePicker = () => {
  //   setToDatePicker(false);
  // };

  // const handleToDate = (pickedToDate) => {
  //   setToDatePicker(false);
  //   setSelectedToDate(Moment(pickedToDate).format("MM-DD-YYYY"));
  // };

  // const compareReminders = (lastUpdateTime) => {
  //   let currentDate = Moment(new Date());
  //   let updatedDate = Moment(lastUpdateTime);
  //   const diffReminderDays = currentDate.diff(updatedDate, "days");
  //   return diffReminderDays;
  // };

  const resetDateValues = () => {
    // setEnablePagination(true);
    // setLoadingQuestions(false);
    // setEnableCalendar(false);
    // setFromDatePicker(false);
    // setToDatePicker(false);
    // setShowScriptMainHeader(false);
    // setCompareAnswers(Array(200).fill(false));
  };

  const ShowDates = () => {
    return (
      <div
        className="scrollmenu"
        style={{
          backgroundColor: "#f5f5f5",
          borderRadius: "10px",
          marginTop: "5px",
        }}
      >
        {selectedDates.map((item, index) => (
          <div
            key={index}
            className="scrollItem"
            onClick={() => getSelectedDate(item)}
          >
            <span
              className="answerPresetItem"
              style={{
                backgroundColor: item === selectedDate ? "#6a347d" : "#ffffff",
                color: item === selectedDate ? "#fff" : "#000",
              }}
            >
              {item}
            </span>
          </div>
        ))}
      </div>
    );
  };

  const ShowQuestions = (cardWidth) => {
    return (
      <div>
        {questionHistoryList[0]?.questionList
          ?.slice(
            0,
            showAllScripts ? questionHistoryList[0]?.questionList.length : 2
          )
          .map((question) => (
            <div style={{ marginBottom: "10px" }}>
              <ScriptCard
                questionInfo={question}
                profileNames={profileNames}
                selectedDate={selectedDate}
                cardWidth={cardWidth}
              />
            </div>
          ))}
      </div>
    );
  };

  return (
    <div
      style={{
        background: "#FFF",
        borderRadius: "10px",
        // padding: "28px"
      }}
    >
      <Row justify={"space-between"}>
        <Col>
          <MainHeader
            title={`Recent Activity ( ${
              questionHistoryList[0]?.questionList.length || 0
            } )`}
          />
        </Col>

        <Col>
          {questionHistoryList[0]?.questionList.length > 2 && (
            <span
              style={{
                fontSize: "18px",
                textAlign: "center",
                cursor: "pointer",
                color: "#6a347d",
                textDecoration: "underline",
                fontWeight: "normal",
              }}
              onClick={() => setShowAllScripts(true)}
            >
              View All
            </span>
          )}
        </Col>
      </Row>

      <div
        style={{
          minHeight: "315px",
          maxHeight: "315px",
          overflowY: "hidden",
          marginTop: selectedDates?.length > 0 ? "10px" : "-10px",
        }}
      >
        {selectedDates?.length > 0 && <ShowDates />}

        <div>
          {questionHistoryList[0]?.questionList.length > 0 ? (
            <div
              style={{
                background: "#f5f5f5",
                padding: "10px",
                maxHeight: "220px",
                overflow: "auto",
                marginTop: "24px",
                borderRadius: "10px",
              }}
            >
              {ShowQuestions(screenResolutionWidth)}
            </div>
          ) : (
            <Row justify={"center"}>
              <Col
                style={{
                  padding: "30px",
                  textAlign: "center",
                  marginTop: "50px",
                }}
              >
                <FolderOpenOutlined
                  style={{ fontSize: "100px", color: "#ccc" }}
                />
                <h3 style={{ textAlign: "center", color: "#ccc" }}>
                  Recent Activity Not Found
                </h3>
              </Col>
            </Row>
          )}
        </div>

        <Drawer
          title={null}
          placement="right"
          onClose={() => setShowAllScripts(false)}
          open={showAllScripts}
          width={isMobileDevice ? "100%" : "75%"}
        >
          <Row justify={"space-between"}>
            <Col>
              <MainHeader title={"Recent Activity"} />
            </Col>
            <Col>
              <span
                style={{ fontSize: "18px", color: "tomato", cursor: "pointer" }}
              >
                Close{" "}
                <CloseSquareFilled onClick={() => setShowAllScripts(false)} />
              </span>
            </Col>
          </Row>

          {selectedDates?.length > 0 && <ShowDates />}

          <div
            style={{
              marginTop: "10px",
              background: "#f5f5f5",
              padding: "20px",
              borderRadius: "10px",
            }}
          >
            {ShowQuestions(null)}
          </div>
        </Drawer>
      </div>
    </div>
  );
}
